import { capitalizeName } from 'helpers/textHelpers';
import { FlexTableCellItem } from '../../components/FlexTable/types';
import { displayText } from '../formatHelpers';
import { Locale, en } from '../../locales';

interface WorkerProtectionData {
  productName: string;
  signalword: string;
  rup: string;
  ppe: string;
  ppereentry: string;
  key: string;
}

const dataKeyStyles = { width: 80 };

export const getWorkerProtectionTableRows = (
  data: WorkerProtectionData,
  locale: Locale = en
): FlexTableCellItem[][] => {
  return [
    [
      {
        label: displayText(data.productName)
      }
    ],
    [
      {
        label: locale.worker_protection.signal_word,
        styles: dataKeyStyles
      },
      {
        label: displayText(data.signalword?.toUpperCase())
      }
    ],
    [
      {
        label: locale.worker_protection.rup,
        styles: dataKeyStyles
      },
      {
        label: displayText(capitalizeName(data.rup))
      }
    ],
    [
      {
        label: locale.worker_protection.ppe,
        styles: dataKeyStyles
      },
      {
        label: displayText(data.ppe)
      }
    ],
    [
      {
        label: locale.worker_protection.reEntry,
        styles: dataKeyStyles
      },
      {
        label: displayText(data.ppereentry)
      }
    ]
  ];
};

export default getWorkerProtectionTableRows;
